import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { push } from 'connected-react-router';
import moment from 'moment';
import LoadingWrapper from 'components/Common/LoadingWrapper';

class ImyFormTable extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    ImyForms: PropTypes.shape(),
    isGettingImyForms: PropTypes.bool,
  };

  static defaultProps = {
    ImyForms: null,
    isGettingImyForms: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  navigateToImyStructure(form) {
    const { dispatch } = this.props;

    if (form.parentFormId !== null) {
      dispatch(push(`/w8imystructure/${ form.parentFormId }/${ form.topLevelAccountId }`));
    }
  }

  render() {
    const {
      isGettingImyForms,
      ImyForms
    } = this.props;

    function dateFormatter(value, format) {
      return moment(value).format(format);
    }

    function getEffectiveDate(form) {
      if (form.uploadedDate !== null) {
        return `${ dateFormatter(form.uploadedDate, 'MMM DD, YYYY HH:mm:ss') }`;
      }
      return 'N/A';
    }

    return (
      <div>
        { isGettingImyForms && <LoadingWrapper loaded={ !isGettingImyForms } /> }
        { ImyForms && <div>
          <div>
            <table className="table table-striped table-hover table-bordered">
              <thead>
                <tr>
                  <th style={ { textAlign: 'center' } }>Top Level IMY Customer</th>
                  <th style={ { textAlign: 'center' } }>Top Level IMY Account</th>
                  <th style={ { textAlign: 'center' } }>Uploaded At</th>
                  <th style={ { textAlign: 'center' } }>View</th>
                </tr>
              </thead>
              <tbody>
                { ImyForms && ImyForms.imyforms
                && ImyForms.imyforms.length > 0 && ImyForms.imyforms.map(form => (
                  <tr key={ form.parentFormId }>
                    <td align="center">{ form.topLevelCustomer }</td>
                    <td align="center">{ form.topLevelAccount }</td>
                    <td align="center">{ getEffectiveDate(form) }</td>
                    <td align="center">
                      { form.hasAllocationStatement && <button
                        className="btn btn-sm "
                        type="button"
                        title="Show IMY Tree"
                        onClick={ () => this.navigateToImyStructure(form) }
                      >
                        <span className="icon icon-treeview" />
                      </button> }
                    </td>
                  </tr>
                ))}
                { ImyForms.imyforms.length <= 0 && <tr><td colSpan="7" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
              </tbody>
            </table>
          </div>
        </div> }
      </div>
    );
  }
}

export default ImyFormTable;
